import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { AddCommentAction } from 'modules/posts/lib/oneHandlers/add-comment'
import { CreatePostAction } from 'modules/posts/lib/oneHandlers/create-post'
import { DeleteCommentAction } from 'modules/posts/lib/oneHandlers/delete-comment'
import { DeletePostAction } from 'modules/posts/lib/oneHandlers/delete-post'
import { SchedulePostAction } from 'modules/posts/lib/oneHandlers/schedule-post'
import { UpdateCommentAction } from 'modules/posts/lib/oneHandlers/update-comment'
import { UpdatePostAction } from 'modules/posts/lib/oneHandlers/update-post'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  one: {
    createActions: {
      post: CreatePostAction,
      updatePost: UpdatePostAction,
      deletePost: DeletePostAction,
      schedulePost: SchedulePostAction,
      addComment: AddCommentAction,
      updateComment: UpdateCommentAction,
      deleteComment: DeleteCommentAction,
    },
  },
} as const satisfies DomainManifest
